/* Exporting patient appointments state default object. */
export default {
  AppointmentScheduled: [],
  AppointmentCanceled: [],
  AppointmentExpired: [],
  AppointmentDetail: null,
  CancelReasons: [],
  ServiceWaitingList: [],
};
